import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { PolicyDetailsService } from '../../../../../../_services/my-insurance/policy-details.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { AgentNotificationService } from '../../../../../../_services/agent/agent-notification.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-unenrollment-confirm-modal',
  templateUrl: './unenrollment-confirm-modal.component.html',
})
export class UnenrollmentConfirmModalComponent implements OnInit {
  endEnrollOptionsModal: ModalOptions;
  hideModalOnRoute = false;
  bankAccount: any;
  loading = false;
  isAcmic = false;
  hideModal: boolean;
  custom_loader = false;
  policy: any;
  @Input() policyNumber: any;
  @Input() where: any;

  @Output() public closeModal = new EventEmitter();
  @Output() public loaderStatus = new EventEmitter();
  constructor(
    public router: Router,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private policyDetailsService: PolicyDetailsService,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService,
    private policyDataService: PolicyDataService,
    private alertService: AlertService,
    private agentNotification: AgentNotificationService
  ) {
    this.endEnrollOptionsModal = new ModalOptions({
      additionalClasses:
        'modal-small modal-dialog center-on-page confirm-modal font-color',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'endEnrollModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: 'PLEASE_CONFIRM',
      typeOfModal: 'accountConfirm',
      screenReader: true,
      showIcons: true,
      modalName: 'paperless_Unenroll',
    });
  }

  reSync(email): void {
    this.loading = true;
    this.policyDataService.clear();
    this.policyDetailsService.getPolicyDetailsByEmail(email).subscribe(
      () => {
        //dp nothing
      },
      (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
      this.closeModal.emit(true);
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
    this.closeModal.emit(true);
  }

  cancel(policyid): void {
    this.agentNotification.setAgentInfo(this.policy);
    this.agentNotification.setHeader(this.policy);
    this.custom_loader = true;
    const email = this.storageServiceObservablesService.getUserFromStorage();
    if (this.where == 'e-policy' || this.where == 'paperless') {
      this.paperlessService.cancelPaperlessEPolicyV2(policyid, email).subscribe(
        () => {
          this.cancelSuccess(email, policyid);
        },
        (error) => {
          this.cancelErro(error, policyid);
        }
      );
    } else if (this.where == 'e-bill') {
      this.paperlessService.cancelPaperlessEBill(policyid, email).subscribe(
        () => {
          this.cancelSuccess(email, policyid);
        },
        (error) => {
          this.cancelErro(error, policyid);
        }
      );
    }
  }

  cancelSuccess(email, policyid) {
    this.custom_loader = false;
    const title = `You've unenrolled!`;
    const policyType = this.policy?.displayType?.label
      ? this.policy.displayType.label.toLowerCase()
      : 'policy';
    let message = `Your ${policyType} policy ${policyid} is unenrolled from paperless.`;

    if (policyid.length === 6) {
      this.reSync(email);

      if (this.where == 'e-policy') {
        message = `Your ${policyType} policy ${policyid} is unenrolled from e-Policy.`;
      } else if (this.where == 'e-bill') {
        message = `Your ${policyType} policy ${policyid} is unenrolled from E-bill.`;
      }
    }

    this.alertService.default(
      message,
      false,
      title,
      undefined,
      'assets/img/images/unenrolled-icon-info.svg'
    );

    this.closeModal.emit(true);
    this.policyDataService.updateStatus({ status: true, where: this.where });
  }

  cancelErro(error, policyId) {
    this.custom_loader = false;
    this.closeModal.emit(true);
    if (error && error.status === 503) {
      this.errorRedirectionService.errorRedirectHandler(error, policyId);
    } else {
      this.errorRedirectionService.errorHandler(
        error,
        'PROBLEM_IN_REQUEST_PROCESSING'
      );
    }
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policy = policyResponse.filter(
          (policy) => policy.policynumber.policyNumber == this.policyNumber
        )[0];
      }
    });
  }
}
